import { omit } from 'lodash-es';

import {
    type PollAnswerElement,
    type PollElement,
    type PollQuestionElement,
} from '@@editor/helpers/Element';

export const removePollId = (element: PollQuestionElement | PollAnswerElement) => ({
    ...element,
    data: { ...omit(element.data, ['pollItemId']) },
});

export const removePollIds = (element: PollElement) => ({
    ...element,
    children: element.children.map((child) => removePollId(child)),
});
